import { Component, input, output } from '@angular/core';
import { LayoutNotification } from '@navfleet/client/shell/domain/models';
import { TopMenuNotificationsListComponent } from './list/top-menu-notifications-list.component';
import { TopMenuNotificationsToolbarComponent } from './toolbar/top-menu-notifications-toolbar.component';

@Component({
    selector: 'fl-top-menu-notifications',
    imports: [TopMenuNotificationsToolbarComponent, TopMenuNotificationsListComponent],
    templateUrl: './top-menu-notifications.component.html',
    styleUrl: './top-menu-notifications.component.scss',
})
export class TopMenuNotificationsComponent {
    public readonly notifications = input<LayoutNotification[]>([]);
    public readonly filteredOutNotificationCount = input<Record<string, number> | null | undefined>(null);
    public readonly pinned = input<boolean>(false);
    public readonly pinClick = output();
}
